import { render, staticRenderFns } from "./rolePower.vue?vue&type=template&id=ca17cc48&"
import script from "./rolePower.vue?vue&type=script&lang=js&"
export * from "./rolePower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports